import { WorksheetBatchUpdateAllTestsTypeId } from 'Components/WorksheetBatchUpdate/WorksheetBatchUpdateDefinitions';
import { getConfigForTest } from 'Components/Worksheets/Config';
import { getWorksheetProviderProps } from 'Components/Worksheets/Core/WorksheetEditorInjectedPropsProvider';
import {
  WorksheetInjectedConsumerProps,
  WorksheetInjectedPropsModifier,
} from 'Components/Worksheets/Core/WorksheetEditorInjectedPropsProvider/types';
import { Guid } from 'Lib/Guid';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { noop } from 'rxjs';
import { InjectedPropsProvider } from '../../../Core/InjectedPropsContext';

type WorksheetBatchUpdateSelectionGridInjectedPropsProviderProps = {
  worksheetId: Guid;
};

/**
 * Provider that injects worksheet properties for a worksheet in the selection grid (identified by id)
 */
let WorksheetBatchUpdateSelectionGridInjectedPropsProvider: React.FC<
  React.PropsWithChildren<WorksheetBatchUpdateSelectionGridInjectedPropsProviderProps>
> = ({ children, worksheetId }) => {
  const locked = useSelector(
    (state) =>
      (state.worksheetBatchUpdate.worksheets[worksheetId]?.status.readonly.locked &&
        !state.worksheetBatchUpdate.worksheets[worksheetId]?.status.readonly.uncheckAllowed) ||
      state.worksheetBatchUpdate.status.applyingUpdate ||
      state.worksheetBatchUpdate.status.checking
  );

  const typeId = useSelector((state) => state.worksheetBatchUpdate.typeId);

  const config = useMemo(
    () => (typeId && typeId !== WorksheetBatchUpdateAllTestsTypeId ? getConfigForTest(typeId) : null),
    [typeId]
  );

  const getProviderProps = useCallback(
    (consumerProps: WorksheetInjectedConsumerProps, modifiers: Array<WorksheetInjectedPropsModifier>) =>
      getWorksheetProviderProps(
        consumerProps,
        {
          worksheetId,
          locked,
          setValue: noop,
          synchronise: noop,
          worksheetSelector: (state) => state.worksheetBatchUpdate.worksheets[worksheetId]?.syncModel_synced, // Use last synced value
          worksheetConfigSelector: (_) => config,
          worksheetTypeSelector: (state) => state.worksheetBatchUpdate.worksheets[worksheetId]?.worksheetType,
        },
        modifiers
      ),
    [locked, worksheetId, config]
  );

  return <InjectedPropsProvider getProviderProps={getProviderProps}>{children}</InjectedPropsProvider>;
};

export { WorksheetBatchUpdateSelectionGridInjectedPropsProvider };
export default WorksheetBatchUpdateSelectionGridInjectedPropsProvider;
